module.exports = __webpack_public_path__ + "static/media/employee-placeholder.495e5e00.png";